import { useEffect } from 'react';

import { VerificationCodeField } from 'libs/form/fields/VerificationCodeField';
import { useField } from 'libs/form/fields/useField';

import {
  useFormContext,
  CODE_LENGTH,
} from '../../../forms/verificationCodeForm';

interface Props {
  fieldName?: string;
}

export const FormContent = ({ fieldName = 'code' }: Props) => {
  const { errors, handleSubmit } = useFormContext();

  const { field, helpers } = useField(fieldName);

  useEffect(() => {
    const codeValue = field.value;

    if (codeValue && String(codeValue).length === CODE_LENGTH) {
      handleSubmit();
    }
  }, [field.value, handleSubmit]);

  useEffect(() => {
    const codeValue = field.value;
    if (
      codeValue &&
      errors &&
      String(codeValue).length === CODE_LENGTH &&
      errors.code
    ) {
      helpers.setValue('');
    }
  }, [errors, helpers, field.value]);

  return <VerificationCodeField length={CODE_LENGTH} name={fieldName} />;
};
